var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.4045,0C17.0359,0,17.5477,0.513256,17.5477,1.14638C17.5477,1.77949,17.0359,2.29275,16.4045,2.29275L2.40382,2.29275L2.40382,25.7262L23.4316,25.7262L23.4316,20.048C23.4316,19.3957,23.9588,18.867,24.6093,18.867C25.2597,18.867,25.787,19.3957,25.787,20.048L25.787,25.7926C25.787,27.0117,24.8014,28,23.5857,28L23.583,28L2.26146,27.9739C1.01205,27.9724,0,26.9563,0,25.7034L0,2.27049C0,1.01652,1.01371,0,2.26423,0L16.4045,0ZM19.8435,0.614009C19.9611,0.672287,20.0563,0.767741,20.1144,0.885648L22.7026,6.13669L28.4882,6.97847C28.8148,7.02599,29.0411,7.32999,28.9937,7.65744C28.9748,7.78804,28.9135,7.90874,28.8192,8.00079L24.6332,12.0862L25.6216,17.8562C25.6774,18.1823,25.4591,18.4921,25.1338,18.5481C25.0044,18.5704,24.8712,18.5493,24.755,18.4881L19.5787,15.7633L14.4024,18.4881C14.1102,18.6419,13.749,18.5291,13.5957,18.2361C13.5346,18.1195,13.5136,17.986,13.5358,17.8562L14.5242,12.0862L10.3383,8.00079C10.1018,7.76996,10.0967,7.39066,10.3269,7.15352C10.4186,7.05896,10.539,6.99742,10.6692,6.97847L16.4548,6.13669L19.0431,0.885649C19.1893,0.589003,19.5476,0.467406,19.8435,0.614009ZM19.563,3.9615L17.6545,7.83927L13.3869,8.4611L16.4749,11.4795L15.746,15.7416L19.563,13.7293L23.3801,15.7416L22.651,11.4795L25.7391,8.4611L21.4715,7.83924L19.563,3.9615Z",
    fill: "#333333",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishIcon);
export default __webpack_public_path__ + "static/media/wish-icon.516b4036e92d0906219ab37b9e9440ae.svg";
export { ForwardRef as ReactComponent };